export default "__VITE_ASSET__DoGhpPwv__"